var $ = require('../../../jCube');

exports.controlPromocode = {

    build: function(_data) {
        return $.assign({}, _data, {
            tagName: 'div',

            id: null,
            name: null,
            className: '',
            label: null,

            inputId: _data.id,
            inputName: _data.name,
            inputClassName: _data.className,
            inputLabel: _data.label,

            buttonId: 'btn-promocode-submit',
            buttonName: 'btn-promocode-submit',
            buttonClass: 'btn btn-promocode-submit',
            buttonLabel: 'Застосувати',
            container: {
                className: 'fb-promocode'
            },
            render: this.render
        });
    },

    render: function(dom) {

        var input, info, label, wrapper, button;

        wrapper = document.createElement('div');
        wrapper.className = 'promocode-wrapper';

        label = document.createElement('label');
        label.htmlFor = this.inputId;
        label.innerHTML = this.inputLabel;
        wrapper.appendChild(label);

        input = document.createElement('input');
        input.setAttribute('id', this.inputId);
        input.setAttribute('name', this.inputName);
        input.className = this.inputClassName;
        input.setAttribute('type', 'text');
        wrapper.appendChild(input);

        info = document.createElement('span');
        info.setAttribute('id', 'contact-promocode-info');
        info.className = 'contact-promocode-info';
        wrapper.appendChild(info);

        dom.appendChild(wrapper);

        button = document.createElement('button');
        // button.setAttribute('id', this.buttonId);
        button.setAttribute('name', this.buttonName);
        button.className = this.buttonClass;
        button.setAttribute('type', 'button');
        button.innerHTML = this.buttonLabel;
        wrapper.appendChild(button);

        dom.appendChild(button);

        return dom;
    }
};
